import { createChangeSignal } from "../../../shared/state/changeSignal";

/**
 * "The project's releases changed here": a release was made or published, or the project's
 * ResearchSpace setting changed, so the Data model's releases list and the settings' Export section read them
 * again, also when the release ran in the split view's other pane.
 */
const releases = createChangeSignal("releases");

export const notifyReleasesChanged = releases.notify;
export const onReleasesChanged = releases.subscribe;
